var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartMetrics',{attrs:{"height":"177px","chartData":_vm.dataChart}})
}
var staticRenderFns = []

export { render, staticRenderFns }